import React from 'react';
interface ImageSectionProps {
  src: string;
  alt: string;
  caption?: string;
  align?: 'left' | 'right' | 'center';
  width?: string;
}
export const ImageSection = ({
  src,
  alt,
  caption,
  align = 'center',
  width = 'full'
}: ImageSectionProps) => {
  const alignmentClasses = {
    left: 'float-left mr-4 mb-2',
    right: 'float-right ml-4 mb-2',
    center: 'mx-auto'
  };
  const widthClasses = {
    full: 'w-full',
    '3/4': 'w-full md:w-3/4',
    '2/3': 'w-full md:w-2/3',
    '1/2': 'w-full md:w-1/2',
    '1/3': 'w-full md:w-1/3'
  };
  return <figure className={`${align === 'center' ? 'flex flex-col items-center' : ''} mb-6`} data-id="element-199">
      <img src={src} alt={alt} className={`${alignmentClasses[align]} ${widthClasses[width as keyof typeof widthClasses] || 'w-full'} rounded-lg shadow-sm`} data-id="element-200" />
      {caption && <figcaption className="text-xs text-gray-500 italic mt-2 text-center max-w-md" data-id="element-201">
          {caption}
        </figcaption>}
    </figure>;
};